import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
 
 

export const getServiceShopPaymentGroup = createAsyncThunk(
  '/getServiceShopPaymentGroup',
  async () => {
    const response = await axios.get(`/GetServiceShopPaymentGroup`);
    return response.data;
  }
);

export const getWarrantyPaymentGroup = createAsyncThunk(
    '/getWarrantyPaymentGroup',
    async () => {
      const response = await axios.get(`/GetWarrantyPaymentGroup`);
      return response.data;
    }
  );


 
const paymentgroupSlice = createSlice({
  name: 'paymentgroup',
  initialState: {
    loading: false,
    error: '',
    ServiceShopPaymentGroup: [],
    WarrantyPaymentGroup: [] 
  },
  reducers: {
   
  },

  extraReducers: {
    [getServiceShopPaymentGroup.pending]: (state) => {
      state.loading = true;
    },
    [getServiceShopPaymentGroup.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getServiceShopPaymentGroup.fulfilled]: (state, action) => {
      state.ServiceShopPaymentGroup = action.payload;
      state.loading = false;
    },
    [getWarrantyPaymentGroup.pending]: (state) => {
      state.loading = true;
    },
    [getWarrantyPaymentGroup.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWarrantyPaymentGroup.fulfilled]: (state, action) => {
      state.WarrantyPaymentGroup = action.payload;
      state.loading = false;
    } 
  }
});

export const paymentgroupActions = paymentgroupSlice.actions;

export default paymentgroupSlice;
